import React from "react";
import downArrowSmall from "svg/downArrowSmall.svg";
import upArrowSmall from "svg/upArrowSmall.svg";

const Header = ({
  tableHeader,
  sorting,
  onSorting,
  isSearchTable,
  isSelectAllChecked,
  handleSelectAll,
  isLaborTable,
  isLaborDetails,
  isLaborTaxDisabled,
}) => {
  const { dataKey, order } = sorting;

  const onSortingChange = (field) => {
    onSorting(field);
  };

  return (
    <thead className="table-root__header">
      <tr className="table-root__header__tr">
        {tableHeader.map((col) => {
          if (col.name === "Checkbox") {
            return (
              <th
                key={col.id}
                className={`table-root__header__tr__th table-root__header__tr__th__checkbox ${isLaborDetails ? "labor" : "checkBox-padding"} table-root__header__tr__th__fixed-col`}
              >
                <div className="d-flex">
                  <div className="d-flex checkbox-dropdown">
                    <input
                      type="checkbox"
                      aria-label="Checkbox select all of rows"
                      className="table-root__header__tr__th__checkbox--input"
                      checked={isSelectAllChecked}
                      onChange={handleSelectAll}
                      disabled={isLaborTaxDisabled}
                    />
                  </div>
                </div>
              </th>
            );
          } else {
            return (
              <th
                key={col.id}
                className={`table-root__header__tr__th ${col.adj_class ? col.adj_class : "table-root__body__tr__td__text"} ${col.class || ""} 
                             ${isLaborTable ? "align-link" : ""} ${col.name === "Actions" ? "actions-align" : ""}`}
                onClick={() => (col.sortable ? onSortingChange(col.dataKey) : null)}
              >
                <div
                  className={`d-flex ${col.gap_cls ? col.gap_cls : "gap-3"} ${col.name === "Actions" && !isSearchTable ? "" : ""}`}
                >
                  {col.name}
                  {dataKey && dataKey === col.dataKey && (
                    <img src={`${order === "asc" ? upArrowSmall : downArrowSmall}`} />
                  )}
                </div>
              </th>
            );
          }
        })}
      </tr>
    </thead>
  );
};

export default Header;
